document.addEventListener('DOMContentLoaded', function () {
  const stickyContainer = document.querySelector('.sticky-add-to-cart-desktop');
  if (!stickyContainer) return;

  let stickyButton = stickyContainer.querySelector('[data-sticky-atc-desktop-button]');
  const stickyButtonContainer = stickyContainer.querySelector('[data-sticky-atc-desktop-button-container]');
  const stickyImage = stickyContainer.querySelector('[data-sticky-atc-desktop-image]');
  const stickyVariant = stickyContainer.querySelector('[data-sticky-atc-desktop-variant]');
  const stickyPrice = stickyContainer.querySelector('[data-sticky-atc-desktop-price]');

  // Same real-button-proxy pattern as the mobile bar (assets/sticky-cart.js): never
  // fork add-to-cart logic, just click the real button and inherit its fetch,
  // loading state, disabled state, and cart-drawer-open behavior for free.
  let mainButton = document.querySelector('form[action="/cart/add"] button');
  const cartDrawer = document.querySelector('cart-drawer');
  const productModal = document.querySelector('product-modal');
  const footer = document.getElementById('shopify-section-footer') 
              || document.querySelector('footer') 
              || document.querySelector('[id*="footer"]');

  // For PerksExclusive or subscription products: clone ONLY the button element
  // from the main form to avoid copying extra content (forms, callouts, etc.)
  const isSpecialProduct = stickyButtonContainer?.dataset.specialProduct === 'true';
  if (isSpecialProduct && stickyButtonContainer) {
    // For PerksExclusive (non-registered), look for the link inside <set-product-to-add-on-redirect>
    // For PerksExclusive (registered) or subscriptions, use the regular button
    let elementToClone = mainButton;
    const perksExclusiveLink = document.querySelector('set-product-to-add-on-redirect a.button');

    if (perksExclusiveLink) {
      elementToClone = perksExclusiveLink;
    } else if (!mainButton) {
      // If no button found, skip cloning
      console.warn('Sticky ATC: No button found to clone for special product');
      return;
    }

    // Clone only the button/link element (not its parent containers)
    const clonedButton = elementToClone.cloneNode(true);
    clonedButton.setAttribute('data-sticky-atc-desktop-button', '');
    clonedButton.classList.add('sticky-add-to-cart-desktop__button');

    // Remove IDs to avoid duplicates
    clonedButton.removeAttribute('id');
    const elementsWithId = clonedButton.querySelectorAll('[id]');
    elementsWithId.forEach((el) => el.removeAttribute('id'));

    // Clear existing content and append cloned button
    stickyButtonContainer.innerHTML = '';
    stickyButtonContainer.appendChild(clonedButton);

    // Update reference to the cloned button
    stickyButton = clonedButton;

    // Update mainButton reference for consistency
    if (!mainButton) mainButton = elementToClone;
  }

  if (stickyButton) {
    stickyButton.addEventListener('click', (e) => {
      // For cloned links (PerksExclusive "Sign Up to Purchase"), don't stop propagation
      // so the link navigation works naturally
      const isLink = stickyButton.tagName === 'A';
      if (!isLink) {
        e.stopPropagation();
      }

      // Analytics: Set atc-source cookie and publish sticky ATC click event
      document.cookie = 'atc-source=stickyATC; path=/; max-age=10';

      const clickData = {
        pageName: window.location.pathname,
        pageType: document.documentElement.dataset.pageType || 'product',
        moduleName: 'pdp:aplus:stickyAtc',
        linkTitle: 'Add to Cart',
        linkText: 'stickyAtcClick',
        targetURL: null,
        locURL: window.location.pathname,
        filters: null,
        searchTerm: null,
      };
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('page-click', { clickData });
      }

      // For special products (PerksExclusive/subscription), the button/link IS cloned,
      // so we don't need to click mainButton - it works naturally (button submits, link navigates).
      // For regular products, proxy click to the main button.
      if (!isSpecialProduct && !isLink) {
        mainButton?.click();
      }
    });
  }

  // Skip early return if we have a special product with a cloned button/link
  if (!mainButton && !isSpecialProduct) return;

  // NFR #3490: Cache element heights and use ResizeObserver to avoid layout thrashing
  let cachedStickyHeight = 93; // Default: 9.3rem
  let cachedPreviewHeight = 0;
  let rafScheduled = false;

  // Observe sticky container height changes
  const stickyResizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      cachedStickyHeight = entry.borderBoxSize?.[0]?.blockSize || entry.target.offsetHeight;
      scheduleUpdate();
    }
  });
  stickyResizeObserver.observe(stickyContainer);

  // Observe preview bar when it appears (Shopify theme editor)
  function observePreviewBar() {
    const previewBar = document.getElementById('PBarNextFrameWrapper');
    if (previewBar && !previewBar.dataset.observed) {
      previewBar.dataset.observed = 'true';
      const previewResizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          cachedPreviewHeight = entry.borderBoxSize?.[0]?.blockSize || entry.target.offsetHeight;
          scheduleUpdate();
        }
      });
      previewResizeObserver.observe(previewBar);
      observers.push(previewResizeObserver); // Add to cleanup array
      
      // NFR #3490 Edge Case Fix: Use ResizeObserver to get initial height instead of direct read
      // This ensures we get accurate height even if bar is still being styled
      // The ResizeObserver callback above will fire immediately with the current size
    }
  }

  function updateFooterOffset() {
    const previewBar = document.getElementById('PBarNextFrameWrapper');
    const previewOffset = cachedPreviewHeight; // Use cached value

    // Add/remove class based on preview bar presence to apply conditional styling
    if (previewBar && previewOffset > 0) {
      stickyContainer.classList.add('has-preview-bar');
    } else {
      stickyContainer.classList.remove('has-preview-bar');
    }

    if (!footer) {
      stickyContainer.style.setProperty('--sticky-offset', `${previewOffset}px`);
      return;
    }

    const footerRect = footer.getBoundingClientRect();
    const footerOverlap = Math.max(0, window.innerHeight - footerRect.top);

    stickyContainer.style.setProperty('--sticky-offset', `${footerOverlap + previewOffset}px`);
  }

  const observers = [stickyResizeObserver]; // For cleanup

  // Shopify injects the Preview Bar after page load in theme preview.
  // NFR #3490 Edge Case Fix: Watch only direct children of body, not entire DOM subtree
  // The preview bar is added as direct child of body: <div id="PBarNextFrameWrapper">
  const previewBarObserver = new MutationObserver((mutations) => {
    // Only check if a node with ID starting with 'PBar' was added
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.id?.startsWith('PBar')) {
          observePreviewBar();
          scheduleUpdate();
          return; // Found it, stop checking
        }
      }
    }
  });

  // NFR #3490 Performance Fix: Observe only direct children of body (not subtree)
  // This prevents observing every DOM change in the entire page
  previewBarObserver.observe(document.body, {
    childList: true,
    subtree: false, // Only watch direct children of body
  });

  observers.push(previewBarObserver);
  observePreviewBar(); // Check if preview bar already exists

  // Track whether the user has scrolled past the main ATC at least once.
  // Prevents sticky ATC from showing on initial page load if main ATC is below the fold.
  let hasScrolledPastMainButton = false;

  // NFR #3490 Performance Fix: Batch all getBoundingClientRect calls to prevent layout thrashing
  // Read all layout properties in one batch, then make decisions
  const updateVisibility = () => {
    rafScheduled = false; // Reset RAF flag

    // Batch layout reads: Read all rects at once to minimize forced reflows
    const mainButtonRect = mainButton ? mainButton.getBoundingClientRect() : null;
    const footerRect = footer ? footer.getBoundingClientRect() : null;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    // Now use the batched rect data for all checks (no more layout reads)
    const mainButtonOutOfView = mainButtonRect
      ? mainButtonRect.bottom <= 0 || mainButtonRect.top >= viewportHeight
      : false;

    const mainButtonScrolledPast = mainButtonRect ? mainButtonRect.bottom <= 0 : false;

    const footerVisible = footerRect ? footerRect.top < viewportHeight : false;

    // Track if user has scrolled past the main button
    if (mainButtonScrolledPast) {
      hasScrolledPastMainButton = true;
    } else if (!mainButtonOutOfView) {
      // Reset the flag when scrolling back to where main button is visible
      // This ensures sticky bar hides when user scrolls back to the first fold
      hasScrolledPastMainButton = false;
    }

    // Only show sticky ATC if:
    // 1. User has scrolled past the main ATC at least once (prevents showing on page load)
    // 2. Main ATC is currently out of view
    // 3. Footer is not visible
    const shouldShow = hasScrolledPastMainButton && mainButtonOutOfView && !footerVisible;
    stickyContainer.classList.toggle('show', shouldShow);
    stickyContainer.setAttribute('aria-hidden', !shouldShow);
    stickyButton.tabIndex = shouldShow ? 0 : -1;

    // Add padding to body when sticky is visible to prevent footer links from being covered
    // This pushes footer content up so it's visible above the sticky bar AND preview bar
    // NFR #3490: Use cached heights instead of reading offsetHeight on every scroll
    const totalPadding = cachedStickyHeight + cachedPreviewHeight;

    if (shouldShow) {
      document.body.style.paddingBottom = `${totalPadding}px`;
    } else {
      document.body.style.paddingBottom = '';
    }
  };

  // NFR #3490: Throttle updates with requestAnimationFrame (max once per frame)
  function scheduleUpdate() {
    if (!rafScheduled) {
      rafScheduled = true;
      requestAnimationFrame(() => {
        updateFooterOffset();
        updateVisibility();
      });
    }
  }

  // Listen to scroll and resize to update sticky bar visibility
  // NFR #3490: Use scheduleUpdate for RAF throttling instead of direct calls
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true }); // Also passive

  const updateOpenState = () => {
    const isDrawerActive = cartDrawer?.classList.contains('active');
    const isModalOpen = productModal?.hasAttribute('open');
    stickyContainer.style.display = isDrawerActive || isModalOpen ? 'none' : '';
  };

  if (cartDrawer) {
    const obs = new MutationObserver(updateOpenState);
    obs.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    observers.push(obs);
  }
  if (productModal) {
    const obs = new MutationObserver(updateOpenState);
    obs.observe(productModal, { attributes: true, attributeFilter: ['open'] });
    observers.push(obs);
  }

  const updateButtonState = () => {
    const span = mainButton.querySelector('span');
    if (!span || !stickyButton) return;

    // For special products, the button is already cloned and self-updating
    // (it's the actual form button). Skip manual sync to avoid conflicts.
    if (isSpecialProduct) return;

    stickyButton.disabled = mainButton.disabled;
    const stickySpan = stickyButton.querySelector('span');
    if (stickySpan) stickySpan.textContent = span.textContent;
  };

  // Only observe button state changes for regular products
  if (!isSpecialProduct) {
    const buttonObserver = new MutationObserver(updateButtonState);
    buttonObserver.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
    observers.push(buttonObserver);
    updateButtonState();
  }

  const withWidth = (url, width) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${width}`;
  };

  // eslint-disable-next-line no-undef
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event?.data?.variant;
    if (!variant) return;

    const image = variant.featured_image?.src;
    if (stickyImage && image) {
      stickyImage.src = withWidth(image, 122);
      stickyImage.srcset = `${withWidth(image, 122)} 1x, ${withWidth(image, 244)} 2x`;
      stickyImage.alt = variant.featured_image.alt || '';
    }

    if (stickyVariant && Array.isArray(variant.options)) {
      // Don't display variant text if it's just "Default Title" or "Default"
      const hasRealVariants =
        variant.options.length > 1 ||
        (variant.options.length === 1 && variant.options[0] !== 'Default Title' && variant.options[0] !== 'Default');
      if (hasRealVariants) {
        // Display only option values, filtering out any "Default" or "Default Title" values
        const formatValue = (value) => {
          if (!value) return '';
          return value;
        };
        const filteredOptions = variant.options.filter((opt) => opt !== 'Default' && opt !== 'Default Title');
        stickyVariant.textContent = filteredOptions.map(formatValue).join(', ');
      } else {
        stickyVariant.textContent = '';
      }
    }

    // Price formatting/sale-strikethrough markup is intentionally not reimplemented
    // here -- clone it from the section HTML the theme already fetched for this
    // variant change, the same technique product-info.js uses for its own price
    // element, so formatting always matches the buy box exactly.
    const sourcePrice = event?.data?.html?.querySelector?.('[id^="price-"]');
    if (stickyPrice && sourcePrice) {
      stickyPrice.innerHTML = sourcePrice.innerHTML;
    }
  });

  // NFR #3490 Edge Case Fix: Cleanup all observers (including ResizeObservers) to prevent memory leaks
  // This is critical for SPA-style navigation or if theme uses Turbo/pjax
  window.addEventListener('beforeunload', () => {
    observers.forEach((observer) => {
      if (observer && typeof observer.disconnect === 'function') {
        observer.disconnect();
      }
    });
  });

  // Initial visibility check on load - ensure sticky bar is hidden initially
  // The bar should only appear after scrolling past the first fold when inline CTA exits viewport
  stickyContainer.classList.remove('show');
  stickyContainer.setAttribute('aria-hidden', 'true');
  stickyButton.tabIndex = -1;
  updateFooterOffset();
});
